// extracted by mini-css-extract-plugin
export var highlightOriginal = "_5z-0";
export var highlightSuggested = "_5z-1";